import axios from '../utils/axios'

export default {
  async getServers(env = 'dev') {
    try {
      const axiosInstance = axios.getInstance('prod', {}, true)
      let queryParam = ``
      let response = await axiosInstance.get(`/servers${queryParam}`)
      return (!response) ? {servers:[]} : response.data
    } catch (error) {
      console.error(error)
    }
  },
  async getAvgLoad(){
    try {

    } catch (error) {
      console.error(error)
    }
  }
}


// WEBPACK FOOTER //
// ./src/requests/servers.js